<template>
  <div class="booking-box">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  export default {}
</script>

<style lang="scss" scoped>
  @import "../../sass/variables";

  .booking-box {
    background-color: $white;
    padding: 1.4rem 16px;
    border-radius: 15px;
    border: 1px solid $brownGrey;
    margin-bottom: 20px;
    @media (min-width: 640px) {
      padding: 1.4rem 2.2rem;
    }
  }
</style>
